import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { RequestEmail } from "../models/request/request-email";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { NotificationService } from "../../core/services/notification.service";
import { NotificationType } from "../../core/services/notification-type";
import { tap } from "rxjs/operators";

@Injectable()
export class RequestSmsNotificationsService {

	private readonly controllerVersion = '1';
	private readonly controllerName = 'request-sms-notifications';

	constructor(private http: HttpClient, private notificationService: NotificationService) {
	}

	getByRequest(requestId: number): Observable<ActionDataResult<RequestEmail[]>> {
		const url = `${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/by-request/${requestId}`;
		return this.http.get<ActionDataResult<RequestEmail[]>>(url)
			.pipe(tap(resp => {
				if (!resp.isSuccessful) {
					this.notificationService.error({
						title: 'Ошибка',
						message: resp.errorDescription,
						notificationType: NotificationType.SweetAlert
					});
				}
			}, errorResponse => {
				if (errorResponse.status === 904)
					return;
				this.notificationService.error({
					title: 'Ошибка',
					message: errorResponse.error.errorDescription,
					notificationType: NotificationType.SweetAlert
				});
			}));
	}
}
